// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientSearchFilterToolbar_SubBrandFragment = { __typename?: 'SubBrand', id: string, displayName: string };

export type SubBrandOptionsQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  fetchSelectedData: Types.Scalars['Boolean']['input'];
  first: Types.Scalars['Int']['input'];
}>;


export type SubBrandOptionsQuery = { __typename?: 'Query', queryData: { __typename?: 'SubBrandConnection', totalCount: number, edges?: Array<{ __typename?: 'SubBrandEdge', node?: (
        { __typename?: 'SubBrand', id: string }
        & ClientSearchFilterToolbar_SubBrandFragment
      ) | null } | null> | null }, selectedData?: { __typename?: 'SubBrandConnection', totalCount: number, edges?: Array<{ __typename?: 'SubBrandEdge', node?: (
        { __typename?: 'SubBrand', id: string }
        & ClientSearchFilterToolbar_SubBrandFragment
      ) | null } | null> | null } };

export type ClientSearchFilterToolbar_EmployeeFragment = { __typename?: 'Employee', id: string, displayName: string, user: { __typename?: 'User', id: string } };

export type ClientSearchFilterToolbar_TeamFragment = { __typename?: 'Team', id: string, name: string };

export type TeamOptionsQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  fetchSelectedData: Types.Scalars['Boolean']['input'];
  first: Types.Scalars['Int']['input'];
}>;


export type TeamOptionsQuery = { __typename?: 'Query', queryData: { __typename?: 'TeamConnection', totalCount: number, edges?: Array<{ __typename?: 'TeamEdge', node?: (
        { __typename?: 'Team', id: string }
        & ClientSearchFilterToolbar_TeamFragment
      ) | null } | null> | null }, selectedData?: { __typename?: 'TeamConnection', totalCount: number, edges?: Array<{ __typename?: 'TeamEdge', node?: (
        { __typename?: 'Team', id: string }
        & ClientSearchFilterToolbar_TeamFragment
      ) | null } | null> | null } };

export type RelationshipOwnerOptionsQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  fetchSelectedData: Types.Scalars['Boolean']['input'];
  first: Types.Scalars['Int']['input'];
}>;


export type RelationshipOwnerOptionsQuery = { __typename?: 'Query', queryData: { __typename?: 'EmployeeConnection', totalCount: number, edges?: Array<{ __typename?: 'EmployeeEdge', node?: (
        { __typename?: 'Employee', id: string }
        & ClientSearchFilterToolbar_EmployeeFragment
      ) | null } | null> | null }, selectedData?: { __typename?: 'EmployeeConnection', totalCount: number, edges?: Array<{ __typename?: 'EmployeeEdge', node?: (
        { __typename?: 'Employee', id: string }
        & ClientSearchFilterToolbar_EmployeeFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    SubBrandOptions: 'SubBrandOptions' as const,
    TeamOptions: 'TeamOptions' as const,
    RelationshipOwnerOptions: 'RelationshipOwnerOptions' as const
  },
  Fragment: {
    ClientSearchFilterToolbar_SubBrand: 'ClientSearchFilterToolbar_SubBrand' as const,
    ClientSearchFilterToolbar_Employee: 'ClientSearchFilterToolbar_Employee' as const,
    ClientSearchFilterToolbar_Team: 'ClientSearchFilterToolbar_Team' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientSearchFilterToolbar_SubBrandFragmentDoc = gql`
    fragment ClientSearchFilterToolbar_SubBrand on SubBrand {
  id
  displayName
}
    `;
export const ClientSearchFilterToolbar_EmployeeFragmentDoc = gql`
    fragment ClientSearchFilterToolbar_Employee on Employee {
  id
  displayName
  user {
    id
  }
}
    `;
export const ClientSearchFilterToolbar_TeamFragmentDoc = gql`
    fragment ClientSearchFilterToolbar_Team on Team {
  id
  name
}
    `;
export const SubBrandOptionsDocument = gql`
    query SubBrandOptions($search: String, $ids: [ID!], $fetchSelectedData: Boolean!, $first: Int!) {
  queryData: subBrands(where: {displayNameContainsFold: $search}, first: $first) {
    totalCount
    edges {
      node {
        id
        ...ClientSearchFilterToolbar_SubBrand
      }
    }
  }
  selectedData: subBrands(where: {idIn: $ids}) @include(if: $fetchSelectedData) {
    totalCount
    edges {
      node {
        id
        ...ClientSearchFilterToolbar_SubBrand
      }
    }
  }
}
    ${ClientSearchFilterToolbar_SubBrandFragmentDoc}`;

/**
 * __useSubBrandOptionsQuery__
 *
 * To run a query within a React component, call `useSubBrandOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubBrandOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubBrandOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      ids: // value for 'ids'
 *      fetchSelectedData: // value for 'fetchSelectedData'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSubBrandOptionsQuery(baseOptions: Apollo.QueryHookOptions<SubBrandOptionsQuery, SubBrandOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubBrandOptionsQuery, SubBrandOptionsQueryVariables>(SubBrandOptionsDocument, withFetchPolicyContext(options));
      }
export function useSubBrandOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubBrandOptionsQuery, SubBrandOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubBrandOptionsQuery, SubBrandOptionsQueryVariables>(SubBrandOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useSubBrandOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubBrandOptionsQuery, SubBrandOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubBrandOptionsQuery, SubBrandOptionsQueryVariables>(SubBrandOptionsDocument, withFetchPolicyContext(options));
        }
export type SubBrandOptionsQueryHookResult = ReturnType<typeof useSubBrandOptionsQuery>;
export type SubBrandOptionsLazyQueryHookResult = ReturnType<typeof useSubBrandOptionsLazyQuery>;
export type SubBrandOptionsSuspenseQueryHookResult = ReturnType<typeof useSubBrandOptionsSuspenseQuery>;
export type SubBrandOptionsQueryResult = Apollo.QueryResult<SubBrandOptionsQuery, SubBrandOptionsQueryVariables>;
export const TeamOptionsDocument = gql`
    query TeamOptions($search: String, $ids: [ID!], $fetchSelectedData: Boolean!, $first: Int!) {
  queryData: teams(where: {nameContainsFold: $search}, first: $first) {
    totalCount
    edges {
      node {
        id
        ...ClientSearchFilterToolbar_Team
      }
    }
  }
  selectedData: teams(where: {idIn: $ids}) @include(if: $fetchSelectedData) {
    totalCount
    edges {
      node {
        id
        ...ClientSearchFilterToolbar_Team
      }
    }
  }
}
    ${ClientSearchFilterToolbar_TeamFragmentDoc}`;

/**
 * __useTeamOptionsQuery__
 *
 * To run a query within a React component, call `useTeamOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      ids: // value for 'ids'
 *      fetchSelectedData: // value for 'fetchSelectedData'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useTeamOptionsQuery(baseOptions: Apollo.QueryHookOptions<TeamOptionsQuery, TeamOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamOptionsQuery, TeamOptionsQueryVariables>(TeamOptionsDocument, withFetchPolicyContext(options));
      }
export function useTeamOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamOptionsQuery, TeamOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamOptionsQuery, TeamOptionsQueryVariables>(TeamOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useTeamOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamOptionsQuery, TeamOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamOptionsQuery, TeamOptionsQueryVariables>(TeamOptionsDocument, withFetchPolicyContext(options));
        }
export type TeamOptionsQueryHookResult = ReturnType<typeof useTeamOptionsQuery>;
export type TeamOptionsLazyQueryHookResult = ReturnType<typeof useTeamOptionsLazyQuery>;
export type TeamOptionsSuspenseQueryHookResult = ReturnType<typeof useTeamOptionsSuspenseQuery>;
export type TeamOptionsQueryResult = Apollo.QueryResult<TeamOptionsQuery, TeamOptionsQueryVariables>;
export const RelationshipOwnerOptionsDocument = gql`
    query RelationshipOwnerOptions($search: String, $ids: [ID!], $fetchSelectedData: Boolean!, $first: Int!) {
  queryData: employees(
    where: {hasUserWith: [{searchNameContainsFold: $search}]}
    first: $first
  ) {
    totalCount
    edges {
      node {
        id
        ...ClientSearchFilterToolbar_Employee
      }
    }
  }
  selectedData: employees(where: {hasUserWith: [{idIn: $ids}]}) @include(if: $fetchSelectedData) {
    totalCount
    edges {
      node {
        id
        ...ClientSearchFilterToolbar_Employee
      }
    }
  }
}
    ${ClientSearchFilterToolbar_EmployeeFragmentDoc}`;

/**
 * __useRelationshipOwnerOptionsQuery__
 *
 * To run a query within a React component, call `useRelationshipOwnerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationshipOwnerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationshipOwnerOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      ids: // value for 'ids'
 *      fetchSelectedData: // value for 'fetchSelectedData'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRelationshipOwnerOptionsQuery(baseOptions: Apollo.QueryHookOptions<RelationshipOwnerOptionsQuery, RelationshipOwnerOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelationshipOwnerOptionsQuery, RelationshipOwnerOptionsQueryVariables>(RelationshipOwnerOptionsDocument, withFetchPolicyContext(options));
      }
export function useRelationshipOwnerOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelationshipOwnerOptionsQuery, RelationshipOwnerOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelationshipOwnerOptionsQuery, RelationshipOwnerOptionsQueryVariables>(RelationshipOwnerOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useRelationshipOwnerOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RelationshipOwnerOptionsQuery, RelationshipOwnerOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelationshipOwnerOptionsQuery, RelationshipOwnerOptionsQueryVariables>(RelationshipOwnerOptionsDocument, withFetchPolicyContext(options));
        }
export type RelationshipOwnerOptionsQueryHookResult = ReturnType<typeof useRelationshipOwnerOptionsQuery>;
export type RelationshipOwnerOptionsLazyQueryHookResult = ReturnType<typeof useRelationshipOwnerOptionsLazyQuery>;
export type RelationshipOwnerOptionsSuspenseQueryHookResult = ReturnType<typeof useRelationshipOwnerOptionsSuspenseQuery>;
export type RelationshipOwnerOptionsQueryResult = Apollo.QueryResult<RelationshipOwnerOptionsQuery, RelationshipOwnerOptionsQueryVariables>;